import { Injectable } from '@angular/core';


@Injectable()
export class AppSessionStorage {
    constructor() { }

    setLocal(key: string, value: string): boolean {
        try {
            if (window.localStorage) {
                window.localStorage.setItem(key, value);
                return true;
            } else {
                return false;
            }
        } catch (error) {

        }
    }

    getLocal(key: string): any {
        try {
            if (window.localStorage) {
                return window.localStorage.getItem(key);
            } else {
                return false;
            }
        } catch (error) {

        }

    }

    setSession(key: string, value: string): boolean {
        try {
            if (window.sessionStorage) {
                window.sessionStorage.setItem(key, value);
                return true;
            } else {
                return false;
            }
        } catch (error) {
        }

    }

    getSession(key: string): any {
        try {
            if (window.sessionStorage) {
                return window.sessionStorage.getItem(key);
            } else {
                return false;
            }
        } catch (error) {

        }
    }

    clearSession(): void {
        try {
            if (window.sessionStorage) {
                window.sessionStorage.clear();
            }
        } catch (error) {

        }
    }


    clearLocal(): void {
        try {
            if (window.sessionStorage) {
                window.localStorage.clear();
            }
        } catch (error) {

        }
    }
}
